export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-10 gap-12">
          {/* Left Zone - Brand */}
          <div className="md:col-span-4 space-y-6">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-store-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-semibold" style={{ fontFamily: 'Playfair Display, serif' }}>Local Shop</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Your trusted neighborhood destination for quality products and exceptional service since 2014.
            </p>
          </div>

          {/* Center Zone - Contact */}
          <div className="md:col-span-3 space-y-6">
            <h4 className="text-sm uppercase tracking-[0.15em] font-medium">Contact</h4>
            <div className="space-y-3 text-gray-300" style={{ fontSize: '15px', lineHeight: '1.8' }}>
              <p>123 Main Street<br />Downtown, ST 12345</p>
              <a href="tel:+15551234567" className="block hover:text-white transition-colors cursor-pointer">
                (555) 123-4567
              </a>
              <a href="mailto:hello@localshop.com" className="block hover:text-white transition-colors cursor-pointer">
                hello@localshop.com
              </a>
            </div>
          </div>

          {/* Right Zone - Social */}
          <div className="md:col-span-3 space-y-6">
            <h4 className="text-sm uppercase tracking-[0.15em] font-medium">Follow Us</h4>
            <div className="flex gap-5">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center transition-all duration-300 hover:border-[#C67B5C] hover:bg-[#C67B5C] cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center transition-all duration-300 hover:border-[#C67B5C] hover:bg-[#C67B5C] cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center transition-all duration-300 hover:border-[#C67B5C] hover:bg-[#C67B5C] cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-8 py-8">
          <p className="text-center text-sm text-gray-500">
            © {currentYear} Local Shop. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}